<template>
  <div
    v-if="!isLoggedIn"
    :class="componentStyles"
    class="RegistrationBlock"
  >
    <h3>{{ heading }}</h3>

    <social-account-auth-buttons
      :import-comment="importComment"
      :show-text-label="false"
      auth-type="register"
    />

    <div class="Authentication-divider">
      <span class="Authentication-text">
        OR
      </span>
    </div>
    <button
      class="Button Button--primary acc-submit"
      @click="openRegisterModal"
    >
      With an Email
    </button>

    <p class="u-noMargin">
      Already have an account? <a
        href="#"
        @click.prevent="openLoginModal"
      >Log in</a>
    </p>
  </div>
  <div
    v-else
    class="IncrementalData-wrapper"
  >
    <transition>
      <incremental-data
        class="is-rounded has-box-shadow"
      />
    </transition>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import IncrementalData from '@/components/incremental-data/incremental-data-index';
import SocialAccountAuthButtons from '@/components/authentication/common/social-account-auth-buttons';

export default {
  components: {
    SocialAccountAuthButtons,
    IncrementalData,
  },
  mixins: [],

  props: {
    importComment: {
      type: String,
      default: 'Sidebar Signup',
    },
    componentStyles: {
      type: String,
      default: null,
    },
    heading: {
      type: String,
      default: null,
    },
  },

  data() {
    return {
      showRegisterModal: false,
      showLoginModal: false,
    };
  },

  computed: {
    ...mapState('user', {
      isLoggedIn: (state) => state.loggedIn,
    }),
  },
  methods: {
    openLoginModal() {
      this.$bus.$emit('bus:authentication-modal:open-login-modal', { importComment: this.importComment });
    },
    openRegisterModal() {
      this.$bus.$emit('bus:authentication-modal:open-register-modal', { importComment: this.importComment });
    },
  },
};
</script>

<style scoped lang="scss">
  @import "../../../../scss/abstracts/abstracts.scss";
  .RegistrationBlock {
    background: #fff;
    padding: spacing();
    box-shadow: 0 2px 20px 0 rgba(0,0,0,.15);
    margin-bottom: spacing();
    border-radius: radius();

    &.has-extra-padding {
      padding: spacing('lg');
    }
  }

  .Button {
    margin-bottom: spacing();
    display: block;
    width: 100%;
  }

  .IncrementalData-wrapper {
    margin-bottom: spacing();
  }
</style>
